import { render, staticRenderFns } from "./CbsUserMenuConstr.vue?vue&type=template&id=47755474&scoped=true"
import script from "./CbsUserMenuConstr.vue?vue&type=script&lang=js"
export * from "./CbsUserMenuConstr.vue?vue&type=script&lang=js"
import style0 from "./CbsUserMenuConstr.vue?vue&type=style&index=0&id=47755474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47755474",
  null
  
)

export default component.exports